<template>
  <drag-dialog
    :visible.sync="visible"
    :title="`报告编制-上传附件`"
    width="900px"
    height="600px"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm')"
  >
    <el-form v-loading="editLoading" :model="editForm" :rules="rules" ref="editForm" label-width="120px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="12">
          <el-form-item label="报告编号">
            <el-input disabled :value="activeInfo.reportCode" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="委托单位">
            <el-input disabled :value="activeInfo.client" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="检测项目">
            <el-input disabled :value="activeInfo.sampleName" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="附件">
            <image-upload v-model="editForm.imgPath" :modelType="2" :paramsData="{ type: 'upt_car_img' }"></image-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确 认</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import { getFlowInfo, editFlowImages } from '@/api/flow';
import ImageUpload from '@/components/UploadArea/ImageUpload';

export default {
  components: { ImageUpload },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      editLoading: false,
      editForm: { imgPath: '' },
      rules: {
        testedTime: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      submitLoading: false
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val && this.activeInfo.id) {
        this.getFlowInfo();
      }
    }
  },
  methods: {
    async getFlowInfo() {
      const { data } = await getFlowInfo({ entrustmentId: this.activeInfo.entrustmentId });
      this.editForm.imgPath = data?.flow?.imgPath || '';
    },
    handleSubmit() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.submitLoading = true;

          try {
            await editFlowImages({ id: this.activeInfo.flowId, imgPath: this.editForm.imgPath });

            this.$emit('update:visible', false);
            this.$message.success('提交成功!');
          } finally {
            this.submitLoading = false;
          }
        }
      });
    }
  },
  created() {},
  mounted() {}
};
</script>

<style scoped></style>
